import type * as T from 'three';
import { SET_PIECES, type SetPiece } from '@london-life/contracts';
import type { SceneKit } from '@london-life/game/scene/kit';
import type { Draw, Piece } from './common';
import { INDOOR } from './indoor';
import { OUTDOOR } from './outdoor';

// Every set piece the content can name, and how it is drawn (contracts set-pieces.ts lists the names).
export const PIECES: Record<SetPiece, Draw> = { ...INDOOR, ...OUTDOOR } as Record<SetPiece, Draw>;
const known = new Set<string>(SET_PIECES);
export const isSetPiece = (shape: string): shape is SetPiece => known.has(shape);

export function drawPiece(k: SceneKit, shape: SetPiece, piece: Piece, group: T.Group) {
  PIECES[shape]?.(k, piece, group);
}
